export const SCROLL_BOTOOM = 'SCROLL_BOTOOM'
export const REALTIME_TOOLTIP_ID = 'REALTIME_TOOLTIP_ID'